import { useMemo } from "react";

import { useSelector } from "react-redux";

import { TRAFFIC_DIRECTION_COMMON } from "../../constants/traffic/trafficDirection";
import { TRAFFIC_PERIOD_VALUES } from "../../constants/traffic/trafficPeriod";
import { isTrafficChangesModel } from "../../models/traffic/type-guards/isTrafficChangesModel";
import { selectAppliedTrafficSignal } from "../../store/selectors";

export const useTractionTrendPeriod = () => {
    const appliedTrafficSignal = useSelector(selectAppliedTrafficSignal);
    const filters = appliedTrafficSignal?.filters;

    return useMemo(() => {
        if (!filters?.trafficChanges || !isTrafficChangesModel(filters.trafficChanges)) {
            return { trendDirection: "", periodValue: 0 };
        }

        const { direction, period } = filters.trafficChanges;

        return {
            trendDirection: TRAFFIC_DIRECTION_COMMON[direction],
            periodValue: TRAFFIC_PERIOD_VALUES[period],
        };
    }, [filters]);
};
